// extracted by mini-css-extract-plugin
export default {"server-details-container":"ServerSection_server-details-container__05E3P"};